/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import * as Examples from 'Docs/uilib/layout/space/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3",
    p: "p",
    code: "code",
    a: "a"
  }, _provideComponents(), props.components), {VisibleWhenVisualTest} = _components;
  if (!Examples) _missingMdxReference("Examples", false);
  if (!Examples.InnerSpace) _missingMdxReference("Examples.InnerSpace", true);
  if (!Examples.MarginCollapse) _missingMdxReference("Examples.MarginCollapse", true);
  if (!Examples.Margins) _missingMdxReference("Examples.Margins", true);
  if (!Examples.Method1) _missingMdxReference("Examples.Method1", true);
  if (!Examples.Method2) _missingMdxReference("Examples.Method2", true);
  if (!Examples.Method3) _missingMdxReference("Examples.Method3", true);
  if (!Examples.SpaceVisibleWhenVisualTestElements) _missingMdxReference("Examples.SpaceVisibleWhenVisualTestElements", true);
  if (!Examples.SpaceVisibleWhenVisualTestPatterns) _missingMdxReference("Examples.SpaceVisibleWhenVisualTestPatterns", true);
  if (!Examples.SpaceVisibleWhenVisualTestReset) _missingMdxReference("Examples.SpaceVisibleWhenVisualTestReset", true);
  if (!VisibleWhenVisualTest) _missingMdxReference("VisibleWhenVisualTest", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Demos"
    }), "\n", _jsx(_components.h3, {
      children: "Spacing method #1"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "Space"
      }), " component. The RedBox is only to visualize the result."]
    }), "\n", _jsx(Examples.Method1, {}), "\n", _jsx(_components.h3, {
      children: "Spacing method #2"
    }), "\n", _jsx(_components.p, {
      children: "Define the space directly."
    }), "\n", _jsx(Examples.Method2, {}), "\n", _jsx(_components.h3, {
      children: "Spacing method #3"
    }), "\n", _jsxs(_components.p, {
      children: ["Using ", _jsx(_components.code, {
        children: "createSpacingClasses"
      }), " or ", _jsx(_components.code, {
        children: "createSpacingProperties"
      }), "."]
    }), "\n", _jsx(Examples.Method3, {}), "\n", _jsxs(_components.h3, {
      children: ["Responsive ", _jsx(_components.code, {
        children: "innerSpace"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["For \"padding\" inside the space component, you can use the property ", _jsx(_components.code, {
        children: "innerSpace"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["It supports the same API as the ", _jsx(_components.code, {
        children: "space"
      }), " prop."]
    }), "\n", _jsxs(_components.p, {
      children: ["But in addition it supports ", _jsx(_components.a, {
        href: "/uilib/usage/layout/media-queries",
        children: "media query breakpoints"
      }), ", such as ", _jsx(_components.code, {
        children: "small"
      }), ", ", _jsx(_components.code, {
        children: "medium"
      }), " and ", _jsx(_components.code, {
        children: "large"
      }), "."]
    }), "\n", _jsx(Examples.InnerSpace, {}), "\n", _jsx(_components.h3, {
      children: "Spacing with no margin collapse, due to the flex usage"
    }), "\n", _jsx(Examples.MarginCollapse, {}), "\n", _jsx(_components.h3, {
      children: "All four values will result in an equivalent margin"
    }), "\n", _jsx(Examples.Margins, {}), "\n", _jsx(_components.h3, {
      children: "Visual space testing"
    }), "\n", _jsx(Examples.SpaceVisibleWhenVisualTestPatterns, {}), "\n", _jsxs(VisibleWhenVisualTest, {
      children: [_jsx(Examples.SpaceVisibleWhenVisualTestElements, {}), _jsx(Examples.SpaceVisibleWhenVisualTestReset, {})]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
